// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2mIXw","header":"PatientQuestionnaire_header__2Y1nx","info":"PatientQuestionnaire_info__1B_TQ"};